import type { CSSProperties, ReactNode } from 'react';

type Color = 'navy' | 'accent' | 'green' | 'red' | 'live' | 'gray';

interface PillProps {
  children: ReactNode;
  color?: Color;
  style?: CSSProperties;
}

const palette: Record<Color, { bg: string; fg: string }> = {
  navy: { bg: 'rgba(15,30,61,.08)', fg: '#0f1e3d' },
  accent: { bg: 'rgba(244,185,58,.18)', fg: '#6b4a00' },
  green: { bg: 'rgba(31,157,85,.12)', fg: '#0f6b34' },
  red: { bg: 'rgba(208,70,60,.12)', fg: '#8a2a22' },
  live: { bg: '#d0463c', fg: '#fff' },
  gray: { bg: 'rgba(15,30,61,.05)', fg: '#5b6578' },
};

export function Pill({ children, color = 'navy', style }: PillProps) {
  const p = palette[color];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: p.bg,
        color: p.fg,
        padding: '3px 8px',
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {children}
    </span>
  );
}
